<script>
import Layout from "@layouts/form";
import ExpedienteTipo from "@forms/ExpedienteTipo";

export default {
  page: {
    title: "Detalhes | Tipo de expediente"
  },
  components: { Layout, ExpedienteTipo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tipo de Expediente",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tipo de Expediente",
          href: "/ExpedienteTipo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ExpedienteTipo :editable="editable"></ExpedienteTipo>
    </div>
  </Layout>
</template>
